export default __webpack_public_path__ + "static/media/DARK_ICONA2.e5c62342.svg";